
function AlarmChart() {
    /// <summary>
    /// This object provides client-side functions for the Chart.Events.AlarmChart.vb <br/>
    /// It generates a simple empty chart and fills the series by a getData()-request. <br/>
    /// <br/>
    /// Author: AFU<br />
    /// Date: 22.7.2017<br />
    /// Copyright ©: EUDT GmbH 2019 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 15.10.2019                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.minEdit = 0;
    this.maxEdit = 0;
    this.digits = 2;
    this.dataTypeEmax = 1;

}

AlarmChart.prototype = new vcTemplate();

AlarmChart.prototype.init = function () {
    /// <summary>
    /// This function inits the chart. 
    /// </summary>
    var me = this;
    var i, j;
    var data ;
    var s = [];
    var axis = 0;
    var name = "";
    var style = "";
    var seriesType = "line";
    var lineWidth = 2;
    try {


        if (me.error) { return false; }

        if (me.chartData === null) {
            me.showInfo(me.resources.naDataForThatPeriod);
            return false;
        } 
        //let's save it - we have to find out the real min/max later on.
        me.minEdit = me.min;
        me.maxEdit = me.max;

        me.chartSeries = [];


        me.showInfo("", "", false);
        var ro = new RampOptions();

        var chart = ro.getTheme();

        //chart.title = { text: me.alarmName }
        chart.chart.boost = { useGPUTranslations: true }
        chart.chart.animation = false;
        chart.chart.defaultSeriesType = seriesType;
        chart.chart.marginLeft = 100;
        Highcharts.setOptions({ global: {useUTC: false } });
        chart.xAxis.min = new Date($.datepicker.formatDate('yy/mm/dd',$.datepicker.parseDate('dd.mm.yy', me.parameter.StartDate))).getTime();
        chart.xAxis.max = new Date($.datepicker.formatDate('yy/mm/dd', $.datepicker.parseDate('dd.mm.yy', me.parameter.EndDate)));
        chart.xAxis.max = chart.xAxis.max.setDate(chart.xAxis.max.getDate() + 1);
        chart.xAxis.labels.rotation = -90; 
        chart.xAxis.type = 'datetime';
        chart.xAxis.tickPixelInterval = 50;
        chart.xAxis.dateTimeLabelFormats = { day: '%d.%m.'};
        chart.plotOptions = { series: { marker: { enabled: false } }}


        chart.tooltip.formatter = function () { return this.series.name.n + '<br/><u>' + moment(new Date(this.x)).format('DD.MM.YYYY HH:mm:ss') + '</u><br/><b>' + Highcharts.numberFormat(this.y, me.digits, ',', '.') + '</b> [' + this.series.name.u + ']' };
        chart.tooltip.positioner = function () { return { x: 0, y: 0 }; }
        chart.legend = { squareSymbol: true, enabled: true, labelFormatter: function () { return this.name.n + ' [' + this.name.u + ']' } }

        data = JSON.parse(me.chartData);

      
        //for emax we add 
        if (me.dataType === me.dataTypeEmax) {


            if (data.length < 2) {
                me.showInfo(me.resources.naDataForThatPeriod);
                return true;
            }
            var add = [];
            var add1 = [];
            var m;
            var c = 0;
            for (i = 0; i < data[1].length; i++) {
                add.push([...data[1][i]]);
                add1.push([...data[1][i]]);
            }

            for (i = 0; i < add.length; i++) {

                m = moment(add[i][0], "dd.MM.yyyy HH:mm:ss").minutes();
                m = m % 15;
                if (m === 0) {
                    m = 15;
                }
                c = add[i][1] * m / 15;
                add[i][1] = c;
                add1[i][1] = (me.min + ((me.max - me.min) / 2)) * m / 15;
            }
            //we do not need the ist/soll series for the emax - current!!

            if (me.functType !== 7) {
                data.push(add);
                data.push(add1);
            }
        }

        for (j = 0; j < data.length; j++) {
            seriesType = "";
            for (i = 0; i < data[j].length; i++) {
                data[j][i][0] = me.getTimeFromDate(data[j][i][0]);
            }
            switch (j) {
                case 0:
                    style = '';

                    if (me.dataType === me.dataTypeEmax) {
                        lineWidth = 1;
                    } else {
                        lineWidth = 2;
                    }
                  
                    name = me.signalName + " (" + me.resources.archive + ")";
                    break;
                case 1:
                    style = '';
                    lineWidth = 2;
                    name = me.signalName + " (" + me.resources.alarm + ")";
                    break;  
                case 2:
                         seriesType = "area";
                    style = '';
                    lineWidth = 0;
                    name = me.signalName + " (" + me.resources.act + ")";
                    break;  
                case 3:
                    seriesType = "";
                    style = '';
                    lineWidth = 1;
                    name = me.signalName + " (" + me.resources.set + ")";
                    break;  
            default:
            }
            if (me.dataType === me.dataTypeEmax) {
                axis = 0;
            } else {
                if (j < 2) {
                 axis = j;
                }

            }
            s.push({ 'name': { "n": name, "u": me.signalUnitSingle },type:seriesType, 'data': data[j], yAxis: axis, dashStyle: style, lineWidth:lineWidth });
        }

        chart.series = s;

        var plotLines = [];
        if (me.min != me.max) {
            ////creates new plotlines with values rounded to integers
            var minPlot = { value: me.min, color: '#a00', dashStyle: "LongDash", zIndex: 3, width: 2, label: { text: "min" } };
            var maxPlot = { value: me.max, color: '#a00', dashStyle: "LongDash", zIndex: 3, width: 2, label: { text: "max" } };

            plotLines = [minPlot, maxPlot];
        } else {
            var maxPlot = { value: me.max, color: '#a00', dashStyle: "LongDash", zIndex: 3, width: 2, label: { text: "max" } };

            plotLines = [maxPlot];
        }

        //get min/max values
        //get min/max value
        for (i = 0; i < data[0].length; i++) {
            //data[0][i][0] = me.getTimeFromDate(data[0][i][0]);
            if (data[0][i][1] !== null) {
                if (data[0][i][1] > me.maxEdit) {
                    me.maxEdit = data[0][i][1];
                }
                if (data[0][i][1] < me.minEdit) {
                    me.minEdit = data[0][i][1] ;
                } 
            }

        }
       
        me.maxEdit = me.maxEdit * 1.1;
        me.minEdit = me.minEdit * 0.9;



        if ((me.max - me.min) < 2) {
            me.digits = 6;
        }


      
        //alert(me.dataTypeEmax);

        if (data.length > 1 && me.dataType !== me.dataTypeEmax) {
            chart.chart.marginRight = 100;
           
            chart.yAxis = [ {

                
                        labels: {
                            formatter: function () { return Highcharts.numberFormat(this.value, me.digits , ',', '.'); },
                        y: 4,
                        style: {color: '#333333', font: '11px Verdana, helvetica, arial'
                        } }
                , title: { text: me.resources.archive + ' [' + me.signalUnit + ']' },
                    lineColor: '#333333',
                    tickColor: '#333333', lineWidth: 2, tickWidth: 2,showFirstLabel: true, minorTickInterval: null,
                    alternateGridColor: '#f8f8f8',offset: 0
                    },
                    {
                        opposite: true,
                        plotLines: plotLines,
                        labels: {
                            formatter: function () { return Highcharts.numberFormat(this.value, me.digits , ',', '.') ; },
                            y: 4,x: 95,
                            style: {
                                color: '#333333', font: '11px Verdana, helvetica, arial'
                            }
                            , align:"right"
                        }
                        , title: { text: me.resources.alarm },
                        lineColor: '#333333',
                        tickColor: '#333333', lineWidth: 2, tickWidth: 2, showFirstLabel: true, minorTickInterval: null,
                        alternateGridColor: '#f8f8f8', offset: 0
                    }
            ];

            if (me.dataType === me.dataTypeEmax) {
                chart.yAxis[0].title = "";
                chart.yAxis[1].title = "";
                chart.yAxis[0].plotLines = plotLines;
            }


            if (me.functType !== 3) {
                chart.yAxis[0].min = this.minEdit;
                chart.yAxis[0].max = this.maxEdit;
            }

            //set the limits for the second axis for min/max functTypes as well - so we get the same charts
            if (me.functType === 1 || me.functType === 4) {
                chart.yAxis[1].min = this.minEdit;
                chart.yAxis[1].max = this.maxEdit;
            }

        } else {
            chart.chart.marginRight = 12;
            //we start with 0 for eMax
            if (me.dataType === me.dataTypeEmax) {
                chart.yAxis.min = 0;
              
            } else {
                chart.yAxis.min = this.minEdit;
            }
       
            chart.yAxis.max = this.maxEdit;

            chart.yAxis.plotLines = plotLines;
            chart.yAxis.labels = { formatter: function () { return Highcharts.numberFormat(this.value, 2, ',', '.'); } }
            chart.yAxis.title = { text: "" }
        }

        ////if we have pretty small numbers we increase the digits.
        //if ((me.max - me.min) < 2) {
        //    me.digits = 6;
        //}
        //me.digits = 6;

       // console.info(me.minEdit + " - " + me.maxEdit);

     
        chart.chart.zoomType = "xy";
        me.container = me.getRandomIDContainerObj("div-chart-", true);
        me.container.obj.height(me.height - 5);

        me.visual.find("#div-chart").html(me.container.obj);
        Highcharts.chart("div-chart-" + me.container.random, chart);

        return true;
    } catch (ex) { me.writeError('init', ex); return false }

}



AlarmChart.prototype.getTimeFromDate = function (sDate) {
    /// <summary>
    /// Returns a proper date in ms
    /// </summary>
    var me = this;
    var dateTime;
    var aDate;
    try {
        if (me.error) { return false; }
        aDate = sDate.split(" ");
        aDate[0] = $.datepicker.formatDate('dd/mm/yy', $.datepicker.parseDate('dd.mm.yy', sDate));
        dateTime = moment(aDate[0] + ' ' + aDate[1], 'DD/MM/YYYY HH:mm:ss');

        return new Date(dateTime).getTime();

    } catch (ex) { writeError('getTimeFromDate', ex); return ""; }
};


AlarmChart.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('#div-chart').hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};
